import { render } from "./EditJobCategory.vue?vue&type=template&id=f5f2ecd2"
import script from "./EditJobCategory.vue?vue&type=script&lang=js"
export * from "./EditJobCategory.vue?vue&type=script&lang=js"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__